const CARD = { width: 900, height: 1200, padding: 48 };

export function statsText({ label, emoji, confidence, createdAt, ranking = [], appName = "PAWS" }) {
  const when = new Date(createdAt || Date.now()).toLocaleString("it-IT", { dateStyle: "medium", timeStyle: "short" });
  const top = ranking.slice(0, 3)
    .map((item) => `${item.emoji || ""} ${item.label_it || item.id}: ${Math.round((item.probability || 0) * 100)}%`)
    .join("\n");
  return [`${emoji || "🐾"} ${label}: ${Math.round((confidence || 0) * 100)}%`, when, top, `— ${appName}`]
    .filter(Boolean).join("\n");
}

export async function shareText(text, fallbackToast) {
  if (navigator.share) {
    try {
      await navigator.share({ text });
      return "condiviso";
    } catch (error) {
      if (error?.name === "AbortError") return "annullato";
    }
  }
  if (navigator.clipboard?.writeText) {
    await navigator.clipboard.writeText(text);
    fallbackToast?.("Testo copiato negli appunti", "success");
    return "copiato";
  }
  return "non disponibile";
}

export function drawCard(canvas, { thumbnail, label, emoji, confidence, createdAt, ranking = [] }, styles = {}) {
  const context = canvas.getContext("2d");
  if (!context) return canvas;
  const { background = "#f7f4ee", ink = "#1d2a26", accent = "#1f6f5c", muted = "#62716c" } = styles;
  canvas.width = CARD.width;
  canvas.height = CARD.height;
  context.fillStyle = background;
  context.fillRect(0, 0, CARD.width, CARD.height);
  if (thumbnail) context.drawImage(thumbnail, CARD.padding, CARD.padding, CARD.width - CARD.padding * 2, 600);
  context.fillStyle = ink;
  context.font = "bold 64px system-ui, sans-serif";
  context.fillText(`${emoji || "🐾"} ${label}`, CARD.padding, 740);
  context.fillStyle = accent;
  context.font = "bold 48px system-ui, sans-serif";
  context.fillText(`${Math.round((confidence || 0) * 100)}%`, CARD.padding, 810);
  context.fillStyle = muted;
  context.font = "32px system-ui, sans-serif";
  context.fillText(new Date(createdAt || Date.now()).toLocaleString("it-IT", { dateStyle: "medium", timeStyle: "short" }),
    CARD.padding, 870);
  ranking.slice(0, 4).forEach((item, index) => {
    const y = 960 + index * 56;
    const width = Math.max(4, Math.round((item.probability || 0) * (CARD.width - CARD.padding * 2 - 320)));
    context.fillStyle = ink;
    context.font = "30px system-ui, sans-serif";
    context.fillText(`${item.emoji || ""} ${item.label_it || item.id}`, CARD.padding, y);
    context.fillStyle = accent;
    context.fillRect(CARD.padding + 300, y - 24, width, 28);
    context.fillStyle = muted;
    context.fillText(`${Math.round((item.probability || 0) * 100)}%`, CARD.padding + 300 + width + 12, y);
  });
  context.fillStyle = muted;
  context.font = "28px system-ui, sans-serif";
  context.fillText("PAWS · Pet Affect Watch System", CARD.padding, CARD.height - CARD.padding);
  return canvas;
}

export async function shareImage(blob, fileName = "paws.png") {
  const file = new File([blob], fileName, { type: "image/png" });
  if (navigator.canShare?.({ files: [file] }) && navigator.share) {
    try {
      await navigator.share({ files: [file] });
      return "condiviso";
    } catch (error) {
      if (error?.name === "AbortError") return "annullato";
    }
  }
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName;
  link.click();
  setTimeout(() => URL.revokeObjectURL(url), 5000);
  return "scaricato";
}
